import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { logger } from '@/features/help/utils/logger';

interface UseSubmissionCompleteProps {
  completionPath: string;
}

// Purpose: Manage navigation prevention for submission complete page
export const useSubmissionComplete = ({ completionPath }: UseSubmissionCompleteProps): void => {
  const navigate = useNavigate();
  const location = useLocation();

  // Navigation prevention logic
  useEffect(() => {
    logger.info('SubmissionComplete', 'Setting up navigation prevention', {
      url: window.location.href,
      pathname: window.location.pathname,
      referrer: document.referrer,
      timestamp: new Date().toISOString(),
      completionPath,
    });

    // Replace the current history entry to prevent going back
    window.history.replaceState(null, '', location.pathname);

    // Add a new history entry to ensure forward navigation works
    window.history.pushState(null, '', location.pathname);

    const handlePopState = (event: PopStateEvent) => {
      event.preventDefault();

      // Push another state to maintain the submission complete page
      window.history.pushState(null, '', location.pathname);

      // Force replace the history to ensure we can't go back
      navigate(completionPath, { replace: true });
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [navigate, location.pathname, completionPath]);
};
